<template>
    <transition name="fade">
        <div
            v-if="$store.state.auth.checked"
            class="nav-sidebar"
            :class="{ 'sidebar-minified': $store.state.minified }"
        >
            <button
                class="float-right btn mr-2 no-focus"
                title="Réduire / Étendre le menu"
                @click="$store.commit('setMinified', !$store.state.minified)"
            >
                <i class="fa fa-bars toggle-sidebar" />
            </button>

            <div class="clearfix" />

            <transition-group
                tag="ul"
                name="fade"
                class="list-group mt-1"
            >
                <template v-for="menu in menus">
                    <li
                        v-if="!menu.can || $store.getters.can('read-tab', menu.can)"
                        :key="menu.label"
                        class="list-group-item fade-list-item"
                    >
                        <router-link
                            :to="{name: menu.link}"
                            :title="menu.title"
                            :class="{'router-link-exact-active': isSubPathActive(menu)}"
                            class="nav-item-sidebar"
                        >
                            <div @click="switchSideBar(menu.link)">
                                <i
                                    :class="menu.icon"
                                    class="fa mr-2"
                                />
                                <transition-group
                                    name="menu"
                                    tag="span"
                                >
                                    <span
                                        v-if="!$store.state.minified"
                                        :key="menu.label"
                                    >{{ menu.label }}</span>
                                    <span
                                        v-if="!$store.state.minified && menu.children"
                                        :key="menu.link"
                                        class="float-right mr-2 pointer"
                                        title="Afficher/masquer le sous-menu"
                                    >
                                        <i :class="{ 'fa fa-angle-down': sidebar(menu.link), 'fa fa-angle-left': !sidebar(menu.link) }" />
                                    </span>
                                </transition-group>
                            </div>
                        </router-link>
                    </li>

                    <div
                        v-if="!$store.state.minified && menu.children && (!menu.can || $store.getters.can('read-tab', menu.can))"
                        :key="menu.label + '-children'"
                    >
                        <li
                            v-for="subMenu in menu.children"
                            :key="subMenu.label"
                            class="list-group-item fade-list-item pl-4"
                            :class="{ 'sub-sidebar-minified': !sidebar(menu.link) }"
                        >
                            <router-link
                                :to="{name: subMenu.link}"
                                :title="subMenu.label"
                                class="nav-item-sidebar"
                            >
                                <i class="fa fa-angle-right" /> {{ subMenu.label }}
                            </router-link>
                        </li>
                    </div>
                </template>
            </transition-group>
        </div>
    </transition>
</template>

<script>
    import Vue from "vue"

    export default {
        name: "TheSidebar",

        data: function() {
            return {
                openSidebar: {},
                menus: [
                    {
                        label: 'Prospects',
                        icon: 'fa fa-users',
                        link: 'prospects',
                        can: 'prospects',
                        title: 'Listing des prospects',
                    },
                    {
                        label: 'Fiches de créations',
                        icon: 'fa fa-folder-open',
                        link: 'fichesCreations',
                        title: 'Listing des fiches de créations',
                    },
                    {
                        label: 'Dossiers',
                        icon: 'fa fa-folder',
                        link: 'dossiers',
                        title: 'Listing des dossiers',
                        can: 'dossiers',
                    },
                    {
                        label: 'Échanges clients',
                        icon: 'fa fa-comments',
                        link: 'echangesClients',
                        title: 'Listing des échanges clients',
                        can: 'echanges_clients',
                    },
                    {
                        label: 'Fiches de résultats',
                        icon: 'fa fa-file-alt',
                        link: 'fichesResultats',
                        title: 'Listing des Fiches de résultats',
                        can: 'fiches_resultats',
                    },
                    {
                        label: 'Programmes',
                        icon: 'fa fa-building ',
                        link: 'programmes',
                        title: 'Listing des programmes',
                        can: 'programmes',
                    },
                    {
                        label: 'Partenaires',
                        icon: 'fa fa-hands-helping',
                        link: 'partenairesSie',
                        title: 'Gestion des partenaires',
                        can: 'partenaires',
                        children: [
                            { label: 'SIE', link: 'partenairesSie' },
                            { label: 'CGA', link: 'partenairesCga' },
                            { label: 'GREFFE', link: 'partenairesGreffes' },
                            { label: 'Provenances', link: 'partenairesProvenances' },
                        ],
                    },
                    {
                        label: 'Configuration',
                        icon: 'fa fa-tools',
                        link: 'config-lieux-production',
                        title: 'Configuration',
                        can: 'configuration',
                        children: [
                            { label: 'Lieux de production', link: 'config-lieux-production' },
                            { label: 'Lieux de collecte', link: 'config-lieux-collecte' },
                            { label: 'Cabinets', link: 'config-cabinets' },
                            { label: 'Modèles de mails', link: 'config-mails-types' },
                            { label: 'Pièces jointes', link: 'config-fichiers' },
                            { label: 'Pièces justificatives', link: 'config-ged-types' },
                        ],
                    },
                    {
                        label: 'Statistiques',
                        icon: 'fa fa-chart-bar',
                        link: 'statistiques',
                        title: 'Statistiques',
                        can: 'statistiques',
                        children: [
                            { label: 'Statuts', link: 'statistiques' },
                            { label: 'Productions', link: 'stats-production' },
                            { label: 'Avancement Production', link: 'stats-avancement-production' },
                            { label: 'Avancement supervision', link: 'stats-avancement-supervision' },
                            { label: 'Clients Convertis', link: 'stats-clients' },
                            { label: 'Lots réinvestis', link: 'stats-reinvest' },
                        ],
                    },
                    {
                        label: 'Administration',
                        icon: 'fa fa-cog',
                        link: 'adminUsers',
                        title: 'Administration',
                        can: 'administration',
                        children: [
                            { label: 'Utilisateurs', link: 'adminUsers' },
                            { label: 'Equipes', link: 'adminEquipes' },
                            { label: 'Tâches', link: 'adminJobs' },
                            { label: 'Alertes', link: 'adminAlerts' },
                        ],
                    },
                ]
            }
        },

        methods: {
            /**
             * Retourne vrai si c'est un sous chemin d'une route active
             */
            isSubPathActive(menu) {
                return menu.children && menu.children.filter((subMenu) => subMenu.link === this.$route.name).length > 0
            },

            sidebar(link) {
                return _.get(this.openSidebar, link, false)
            },

            switchSideBar(link) {
                const oldValue = this.sidebar(link)
                this.openSidebar = {}
                Vue.set(this.openSidebar, link, !oldValue)
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import "~sass/_variables";

    .nav-sidebar {
        padding-top: 72px;
        box-shadow: inset -1px 0 0 rgba(0, 0, 0, .1);
        height: 100%;
        position: fixed;
        width: $sidebar-width;
        background-color: $sidebar-bg;
        transition: 0.3s all;

        &.sidebar-minified {
            width: $sidebar-minified-width;

            .toggle-sidebar {
                transform: rotate(-90deg);
            }
        }

        .sub-sidebar-minified {
            display: none;
        }

        .pointer {
            cursor: pointer;
        }

        .toggle-sidebar {
            transition: 0.3s all;
        }

        .list-group-item {
            background: none;
            border: none;
            padding: 0;

            .nav-item-sidebar {
                padding: 6px 6px 6px 20px;
                width: 100%;
                color: $black-text;
                display: block;
                font-size: 14px;
                overflow: hidden;
                white-space: nowrap;
                transition: all .25s;

                .fa, .far, .fas {
                    color: $gray-text;
                    width: 15px;
                    transition: all .25s;
                }

                &:hover {
                    text-decoration: none;

                    .fa, .far, .fas {
                        color: $black-text
                    }
                }

                &.router-link-exact-active {
                    color: $primary;

                    .fa, .far, .fas {
                        color: $primary;
                    }
                }
            }
        }
    }
</style>
